<!-- eslint-disable max-len -->
<template>
  <div
    class="preview">
    <div v-if="(!hash || !responseValid) && !loading">
      <h1 class="text-strong text-center">
        {{ $t("preview.invalidParams") }}
      </h1>
    </div>
    <div v-show="responseValid">
      <div class="text-strong flex-tablet items-end">
        <div
          v-if="response.subjects"
          class="mr-1 flex items-center subjectContainer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            aria-hidden="true"
            class="mr-0-5"><path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" /></svg>
          <p class="font-semibold subjectTitle">
            {{ $t("preview.testABTitle") }}
          </p>
          <div class="subjectBox">
            <p
              v-for="subject in response.subjects"
              :key="subject">
              {{ subject }}
            </p>
          </div>
        </div>
        <p
          v-if="response.subject"
          class="font-semibold mr-1">
          {{ response.subject }}
        </p>
        <p> {{ response.preheader }} </p>
      </div>
      <div class="flex-tablet mt-0-5">
        <p
          v-if="response.sender.name || response.sender.email"
          class="text-strong mr-1">
          <span
            class="font-semibold">{{ $t("preview.from") }}: </span>
          {{ response.sender.name }} &lt;
          {{ response.sender.email }} &gt;
        </p>
        <p
          v-if="response.sender.reply_to"
          class="text-strong">
          <span class="font-semibold">{{ $t("preview.to") }}: </span>
          {{ response.sender.reply_to }}
        </p>
      </div>
      <div
        v-if="response.preview_as != 'generic'"
        class="mt-0-5 notification-box">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="mr-0-5"
          viewBox="0 0 20 20"
          fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1
            1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clip-rule="evenodd" />
        </svg>
        <span class="mr-0-5">{{ $t("preview.as") }} </span>
        {{ response.preview_as }}
      </div>

      <iframe
        ref="iframe"
        scrolling="no"
        style="height: 100vh;"
        :class="response.preview_as == 'generic' && 'iframe-border'"
        class="mt-0-5"
        frameBorder="0" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { nextTick } from "vue";

export default {
  data() {
    return {
      apiUrl: null,
      hash: "",
      loading: false,
      response: {
        sender: {
          name: "",
          email: "",
        },
      },
      responseValid: null,
      selectValue: "",
    };
  },
  created() {
    this.loading = true;
    document.title = this.$t("preview.pageTitle");
    document.querySelector("body").style = 'width: 100%;';
    this.getParams();
    window.addEventListener('resize', this.debounce(() => { this.refreshHeight(); }, 500), true);
  },
  mounted() {
    this.getTemplate();
    window.removeEventListener("resize", () => {}, { capture: true });
  },
  methods: {
    debounce(callback, wait) {
      let timerId;
      return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
          callback(...args);
        }, wait);
      };
    },
    getParams() {
      const hashParam = this.$route.params.hash;
      if (!hashParam) return false;
      this.hash = hashParam;
      this.apiUrl = this.hasPreviewLink()
        ? `https://thumbs-prod.s3.us-east-1.amazonaws.com/linkpreviews/${this.hash}.json`
        : `https://d9p51ruvsfm1m.cloudfront.net/templates/preview/share/${this.hash}`;
      return true;
    },
    refreshHeight() {
      const iframeHost = this.$refs.iframe;
      nextTick(() => {
        if (!iframeHost.contentWindow) return;
        iframeHost.style.height = `${iframeHost.contentWindow.document.body.offsetHeight}px`;
      });
    },
    hasPreviewLink() {
      const { path } = this.$route;
      const previewLink = "preview/link";
      if (path.includes(previewLink)) return true;
      return false;
    },
    getTemplate() {
      axios
        .get(this.apiUrl)
        .then((response) => {
          this.responseValid = true;
          const { iframe } = this.$refs;
          if (!iframe) return;
          iframe.contentDocument.open();

          const html = this.hasPreviewLink()
            ? response.data.html
            : response.data.data.html;

          iframe.contentDocument.write(html);
          iframe.contentDocument.close();
          setInterval(() => {
            this.refreshHeight();
          }, 1000);

          this.response = {
            ...(this.hasPreviewLink() ? response.data : response.data.data),
            sender: !this.hasPreviewLink() && response.data.data.sender
              ? response.data.data.sender : this.response.sender,
          };
          this.loading = false;
        })
        .catch(() => {
          this.responseValid = false;
          this.loading = false;
        });
    },
  },
};
</script>
